import React, { useRef, useEffect, useCallback, useState} from 'react';
import {
    setSelectedZObject,
    setWindowPosition,
    setViewableSubPatches
} from 'actions/index.js';
import {connect} from 'react-redux';
import {useDoubleClick} from "components/hooks/useDoubleClick.js";
import {useZObjectWidth} from "components/messaging/useZObjectWidth.js";

const ClosedSubPatch = ({
    subpatch,
    viewableSubPatches,
    setWindowPosition,
    _name,
    setSelectedZObject
}) => { 
    const ref = useRef(undefined);
    const [name, setName] = useState(subpatch.zObject.args[0] || "");
    const [editing, setEditing] = useState(!name || name === "");
    const width = useZObjectWidth({zobject: subpatch.zObject, text: subpatch.zObject._text});

    useEffect(() => {
        setName(_name);
    }, [setName, _name]);

    useEffect(() => {
        if (name !== subpatch.zObject.args[0]) {
            subpatch.zObject.text = "subpatch " + name;
        }
    }, [name]);

    useEffect(() => {
        if (editing && ref.current) {
            ref.current.focus();
        }
    }, [editing]);

    const onDoubleClick = useCallback(() => {
        // first copy the position of this subpatch to next one
        let zobject = subpatch.zObject;
        let {state} = zobject.sequencerEngine;
        let parent = zobject.subSequence;
        if (parent.inletObjects) {
            let position = state.windows.windowPositions[parent.id];
            setWindowPosition(subpatch.id, position);
        }
        let spatches = state.zobject.viewableSubPatches;
        setViewableSubPatches(
            [... spatches, subpatch]);

    }, [subpatch]);
    const onClick = useDoubleClick(onDoubleClick);

    let style = {
    };
    if (!editing) {
        style.width = width;
    }

    let className = "closed-subpatch";
    if (viewableSubPatches.includes(subpatch)) {
        className += " viewing";
    }
    return (
        <div
          onMouseDown={e => setSelectedZObject(subpatch.zObject)}
          style={style} onClick={onClick} className={className}>
        subpatch {editing ?
                  <input
                    ref={ref}
                    placeholder="type name"
                    onBlur={e => setEditing(false)}
                    onChange={e => setName(e.target.value)}
                    value={name} type="text" className="subpatch-name-input"/> :
                  <div
                    onClick={e => setEditing(true)}
                    className="subpatch-name">{name}</div>}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      viewableSubPatches: state.zobject.viewableSubPatches,
      _name: props.subpatch.zObject.args[0]
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setViewableSubPatches: x => dispatch(setViewableSubPatches(x)),
      setWindowPosition: (id, x) => dispatch(setWindowPosition(id, x)),
      setSelectedZObject: (x) => dispatch(setSelectedZObject(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClosedSubPatch);
